// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__30h1G","col":"CardReaderDesc_col__OQ5_Q","label":"CardReaderDesc_label__19Zmt"};